import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Jobs & queues" hint="No Bull/BeeQueue in rr-backend today — placeholder for when async work is added." /> }
